import { render } from "./produto-dropdown-item.vue?vue&type=template&id=7439a4b4"
import script from "./produto-dropdown-item.vue?vue&type=script&lang=js"
export * from "./produto-dropdown-item.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__